import { Box } from "@mui/material";

import { memo } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../store/store";

const CompanyLogo = () => {
  const { logo, logoLogin, logo_dark, mode, name, logoWidth } = useAppSelector(
    (state) => state.theme
  );

  const portalLogo = logoLogin
    ? logoLogin
    : mode === "1"
    ? logo
    : logo_dark
    ? logo_dark
    : logo;

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Link to="/">
        <Box
          component="img"
          src={portalLogo}
          sx={{
            display: "block",
            width: logoWidth || "auto",
            height: "auto",
            maxWidth: "400px",
            minWidth: "100px",
            mb: 2,
          }}
          alt={name}
        />
      </Link>
    </Box>
  );
};

export default memo(CompanyLogo);
